import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import { accessRole } from '../../../../helpers/access_role'

// const peg_nip = JSON.parse(localStorage.getItem('userdata'))?.employee_nip ?? "";
// const peg_uuid = JSON.parse(localStorage.getItem('userdata'))?.employee_uuid ?? "";

var reformatOptionRegion = function(regions) {
  return regions.map(function(region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_nip = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_nip : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_nip : "")

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionGender : [
                { label: "Laki-laki", value: "L" },
                { label: "Perempuan", value: "P" }
            ],
            detail: [],
            selectedGender: "",
            birthOptionProvince : [],
            birthSelectedProvince: "",
            birthOptionCity : [],
            birthSelectedCity: ""
        }
    }

    // Select Area

    handleBirthSelectProvince = (birthSelectedProvince) => {
      this.setState({
        birthSelectedProvince: birthSelectedProvince.value
      });

      // get data city where province selected
      this.updateBloc.regionCityChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)
                      
                      this.setState({
                          birthOptionCity: reformatOptionRegion(response.result)
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      this.updateBloc.fetchRegionCity({
        is_local: 1,
        type : 3,
        parent_uuid : birthSelectedProvince.value
      })
    }

    handleBirthSelectCity = (birthSelectedCity) => {
      this.setState({
        birthSelectedCity: birthSelectedCity.value
      });
    }

    handleSelectGender = (selectedGender) => {
        this.setState({
            selectedGender: selectedGender.value
        });
    }

    // End Select Area

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'file') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.updateBloc.fetchUpdate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response);
                        this.setState({
                            dataForm: {
                              uuid: response.skill_certification_uuid,
                            //   employee_uuid: response.skill_certification_employee_uuid,
                              skill_certification_name: response.skill_certification_name,
                              skill_certification_institution_name: response.skill_certification_institution_name,
                              skill_certification_level: response.skill_certification_level,
                              skill_certification_sk_number : response.skill_certification_sk_number,
                              skill_certification_sk_date : response.skill_certification_sk_date,
                              skill_certification_date : response.skill_certification_date,
                              skill_certification_expire_date : response.skill_certification_expire_date,
                              skill_certification_registration_number : response.skill_certification_registration_number,
                              skill_certification_status : response.skill_certification_status,
                              skill_certification_status_description : response.skill_certification_status_description,
                            },
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })

        // get data province
          this.updateBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionProvince: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRegionProvince({
          is_local: 1,
          type : 2  
        })

        // get data city where province selected
        this.updateBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionCity: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRegionCity({
          is_local: 1,
          type : 3,
          parent_uuid : this.state.birthSelectedProvince
        })
      
    }

    componentWillUnmount(){
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
        this.updateBloc.regionCityChannel?.unsubscribe()
        this.updateBloc.regionProvinceChannel?.unsubscribe()
    }


    render() {
        const { result, detail } = this.state.detail
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="skillcertification"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Edit Data Sertifikat Keahlian</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                      {/* Masih HardCode */}
                                      <AvField
                                            name="uuid"
                                            type="hidden"
                                            id="skill_certification_uuid"
                                            value={this.state.dataForm.uuid}
                                      />
                                      <AvField
                                            name="employee_uuid"
                                            type="hidden"
                                            id="employee_uuid"
                                            value={this.peg_uuid}
                                      />
                                      <AvField
                                            name="employee_nip"
                                            type="hidden"
                                            id="employee_nip"
                                            value={this.peg_nip}
                                      />
                                      {/* Sampai Sini */}

                                         {this.state.dataForm?.skill_certification_status == 2 ?
                                            <Row className="mb-3">
                                                <Col md="12">
                                                    <div class="alert-dismissible fade show alert alert-danger alert-dismissible fade show" role="alert">
                                                        <button type="button" class="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                                                        <i class="uil uil-exclamation-octagon me-2"></i> Catatan Approval : {this.state.dataForm?.skill_certification_status_description}
                                                    </div>
                                                </Col>
                                            </Row>
                                        : '' }

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Lembaga <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="skill_certification_institution_name"
                                                    placeholder="Nama Lembaga..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Lembaga"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skill_certification_institution_name"
                                                    value={this.state.dataForm.skill_certification_institution_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Sertifikat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="skill_certification_name"
                                                    placeholder="Nama Sertifikat..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Sertifikat"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skill_certification_name"
                                                    value={this.state.dataForm.skill_certification_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tingkatan Sertifikat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="skill_certification_level"
                                                    placeholder="Tingkatan Sertifikat..."
                                                    type="text"
                                                    errorMessage="Masukkan Tingkatan Sertifikat"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skill_certification_level"
                                                    value={this.state.dataForm.skill_certification_level}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="skill_certification_sk_number"
                                                    placeholder="Nomor SK..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor SK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skill_certification_sk_number"
                                                    value={this.state.dataForm.skill_certification_sk_number}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal ditetapkan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="skill_certification_sk_date"
                                                    placeholder="Tanggal ditetapkan..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal ditetapkan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skill_certification_sk_date"
                                                    value={this.state.dataForm.skill_certification_sk_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal expired <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="skill_certification_expire_date"
                                                    placeholder="Tanggal expired..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal expired"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skill_certification_expire_date"
                                                    value={this.state.dataForm.skill_certification_expire_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Registrasi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="skill_certification_registration_number"
                                                    placeholder="Nomor Registrasi..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Registrasi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="skill_certification_registration_number"
                                                    value={this.state.dataForm.skill_certification_registration_number}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                        <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                                File Pendukung
                                            </label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="file"
                                                    // defaultValue={detail?.document}
                                                />
                                                <br />
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail?.document != null ? 
                                                        <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.detail.document?.documents_path}>
                                                            <i className="uil-file-download"></i> Download File Sebelumnya
                                                        </a>
                                                        : 'Tidak ada dokumen'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>

                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>
                                                
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?skillcertification">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?skillcertification'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);